module.exports = __webpack_public_path__ + "static/media/process-book.7ab9664f.mov";